const domesticNewsServiceName = "/DomesticNews";
const domesticClientNewsServiceName = "/DomesticNewsClient";

export function domesticNewsService (http)  {
    return {
        getAllDomesticNewsAsync :async (pageNumber, pageSize, sortBy, filters) => {
            const newSort = (sortBy || []).map(item => ({
                member: item.id,
                sortDirection: item.desc ? "Descending" : "Ascending"
            }));


            const filter=filters;
            const data = {
                dataAttribute:{
                    page:pageNumber,
                    pageSize,
                    sorts: newSort.lenght==0?[{member:"StartDate",sortDirection:"Ascending"}]:newSort,
                    filter: filter
                }
            }

            return await http.post(domesticNewsServiceName + '/GetAllDomesticNewsAsync', data);
        },
        saveNewsAsync: async (categoryId, title, description, showDate, daysToShow, file, cover) => {
            let paramObject = {
                categoryId,
                title,
                description,
                showDate,
                daysToShow,
                file,
                cover
              };

            return await http.post(domesticNewsServiceName + '/SaveDomesticNewsAsync', paramObject);
        },
        deleteExistingNewsAsync: async (newsId) => {
            let paramObject = {
                id: newsId
              }

            return await http.post(domesticNewsServiceName + '/DeleteExistingNewsAsync', paramObject);
        },
        getAllClientNewsAsync: async () => {
            return await http.get(domesticClientNewsServiceName + '/GetAllClientNews');
        },
        getAllClientVideoNewsAsync: async () => {
            return await http.get(domesticClientNewsServiceName + '/GetAllClientVideoNews');
        },
        getLatestNewsInformationAsync: async () => {
            return await http.get(domesticClientNewsServiceName + '/GetLatestNewsInformation');
        }        
    }
}